import { render, staticRenderFns } from "./WeddingEventImageModal.vue?vue&type=template&id=da1a91ea"
import script from "./WeddingEventImageModal.vue?vue&type=script&lang=ts"
export * from "./WeddingEventImageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports